import '@rbx/ui';
import React, { FunctionComponent, useMemo } from 'react';
import useContentTableStyles from './ContentTable.styles';
import ContentTableRow, { ContentTableRowProps } from './ContentTableRow';

interface ContentTableProps {
  data: unknown[];
  renderer: (
    row: unknown | { code: string; response: string },
    index?: number,
  ) => ContentTableRowProps;
  className?: string;
}

const ContentTable: FunctionComponent<React.PropsWithChildren<ContentTableProps>> = ({
  className,
  data,
  renderer,
}) => {
  const {
    classes: { tableContainer },

    cx,
  } = useContentTableStyles();
  const rows = useMemo(() => {
    const renderedData = data.map((row) => renderer(row));
    const hasTags = renderedData.find((d) => d.tags);
    const hasSummary = renderedData.find((d) => d.summary);
    return renderedData.map((d, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ContentTableRow key={index} {...d} columnCount={hasTags || hasSummary ? 2 : 1} />
    ));
  }, [data, renderer]);

  return <div className={cx(className, tableContainer)}>{rows}</div>;
};

export default ContentTable;
